<template>
  <v-card>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex class="flex-container-space-between" xs12>
          <h1 class="title grey--text text--darken-1">
            <v-icon class="mr-1">{{$store.state.global.pages.docket.icon}}</v-icon>Trip Entry
          </h1>
          <div>
            <!-- <v-tooltip left>
                            <v-btn class="mr-0" color="grey" flat slot="activator" @click="breaksDialog = !breaksDialog">
                                <v-icon left>add_alarm</v-icon>Breaks 
                            </v-btn>
                            <span>Click to add break and travel information</span>
            </v-tooltip>-->
            <!-- <v-btn flat type="submit" :color="$store.state.global.pages.docket.color">
                            Add
            </v-btn>-->
            <v-menu bottom left>
              <v-btn icon flat color="grey" slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile ripple @click="rateDialog = true">
                  <v-list-tile-action>
                    <v-icon
                      :color="$store.state.global.pages.rate.color"
                    >{{$store.state.global.pages.rate.icon}}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Check rate</v-list-tile-title>
                </v-list-tile>
                <v-list-tile ripple @click="useNightRate = !useNightRate" v-if="!useAltRate">
                  <v-list-tile-action>
                    <v-icon :color="useNightRate ? 'orange' : 'blue'">settings_brightness</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title v-if="!useNightRate">Use night rate</v-list-tile-title>
                  <v-list-tile-title v-if="useNightRate">Use standard rate</v-list-tile-title>
                </v-list-tile>
                <v-list-tile ripple @click="useAltRate = !useAltRate" v-if="!useNightRate">
                  <v-list-tile-action>
                    <v-icon :color="useAltRate ? 'orange' : 'blue'">settings_brightness</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title v-if="!useAltRate">Use alternate rate</v-list-tile-title>
                  <v-list-tile-title v-if="useAltRate">Use standard rate</v-list-tile-title>
                </v-list-tile>
                <v-list-tile ripple @click="useOverrideCost = !useOverrideCost">
                  <v-list-tile-action>
                    <v-icon :color="useOverrideCost ? 'orange' : 'blue'">settings_brightness</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title v-if="!useOverrideCost">Use override cost</v-list-tile-title>
                  <v-list-tile-title v-if="useOverrideCost">Use standard cost</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-flex>
        <trip></trip>
        <v-flex xs12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="trips"
            item-key="name"
            class="elevation-1"
            hide-actions
            :disable-initial-sort="true"
          >
            <template slot="no-data">
              <div class="text-xs-center grey--text subheading">Please enter trip details below.</div>
            </template>

            <template slot="items" slot-scope="props">
              <table-row
                class="green lighten-5"
                :headers="headers"
                :row="props.item"
                parent="Trip"
                :key="props.item.id"
                noDelete
                editComponentPath="addDocket/editTrip"
                persistent
              >
                <v-btn
                  flat
                  color="red lighten-3"
                  icon
                  @click="deleteTrip(props.item)"
                  slot="extraAction"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <td slot="extraCell"></td>
              </table-row>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- RATE DIALOG -->
    <!-- RATE DIALOG -->
    <v-dialog v-model="rateDialog" max-width="700px">
      <pre-rate @close="rateDialog = false"></pre-rate>
    </v-dialog>

    <!-- BREAKS DIALOG -->
    <!-- BREAKS DIALOG -->
    <v-dialog v-model="breaksDialog" max-width="700px">
      <v-card @close="breaksDialog = false">
        <v-card-title>
          <div class="headline">Breaks / Travel (hours)</div>
        </v-card-title>
        <v-container grid-list-xl>
          <layout-no-padding>
            <v-flex xs6 class>
              <v-text-field
                type="number"
                label="Total Breaks (hours)"
                v-model="totalBreaks"
                prepend-icon="alarm_off"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class>
              <v-text-field
                type="number"
                label="Total Travel (hours)"
                v-model="totalTravel"
                prepend-icon="add_alarm"
              ></v-text-field>
            </v-flex>
          </layout-no-padding>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import Trip from "./trip";
import TipService from "@/services/requests/tipService";
import SpoilService from "@/services/requests/spoilService";
import TableRow from "@/components/ui/masterFileTableRow";
import PreRate from "@/components/addDocket/preRate";
export default {
  data() {
    return {
      tripEntry: [true],
      selected: [],
      breaksDialog: false,
      rateDialog: false,
      headers: [
        { text: "Spoil", value: "spoil.name", sortable: false, align: "left" },
        { text: "Tip", value: "tip.name", sortable: false, align: "left" },
        { text: "Weight", value: "siteWeight", sortable: false, align: "left" },
        // { text: 'Site Weight', value: 'tipWeight', sortable: false, align: 'left'  },
        // { text: 'Start Time', value: 'start', sortable: false, align: 'left' },
        // { text: 'End Time', value: 'end', sortable: false, align: 'left' },
        {
          text: "Hours",
          value: "calcHours",
          type: "time",
          sortable: false,
          align: "right"
        },
        { text: "- Breaks", value: "breaks", sortable: false, align: "right" },
        { text: "+ Travel", value: "travel", sortable: false, align: "right" },
        {
          text: "Billable",
          value: "calcBillableHours",
          type: "time",
          sortable: false,
          align: "right"
        },
        { text: "Qty", value: "qty", sortable: false, align: "right" },
        { text: "Rate", value: "rateType", sortable: false, align: "right" },
        { text: "Actions", align: "center", sortable: false }
      ],
      activeTrip: {},
      showTrip: false
    };
  },
  methods: {
    addTrip() {
      this.$store.dispatch("dockets/addTrip");
    },
    deleteTrip(trip) {
      this.$store.commit("dockets/deleteFromArrayStateByValue", {
        prop: "trips",
        value: trip
      });
    },
    getSpoils() {
      SpoilService.getAllSpoils()
        .then(result => {
          this.spoils = result.data.result;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTips() {
      TipService.getAllTips()
        .then(result => {
          this.tips = result.data.result;
        })
        .catch(err => {
          console.log(err);
        });
    },
    openTrip(trip) {
      this.showTrip = true;
      this.activeTrip = trip;
    }
  },
  computed: {
    //Get trips array from store
    trips() {
      return this.$store.getters["dockets/getTrips"];
    },
    tips: Store.getSet({ store: "tips", prop: "tips" }),
    spoils: Store.getSet({ store: "spoils", prop: "spoils" }),
    totalBreaks: Store.getSet({ store: "trips", prop: "totalBreaks" }),
    totalTravel: Store.getSet({ store: "trips", prop: "totalTravel" }),
    useNightRate: Store.getSet({ store: "trips", prop: "useNightRate" }),
    useAltRate: Store.getSet({ store: "trips", prop: "useAltRate" }),
    useOverrideCost: Store.getSet({ store: "trips", prop: "useOverrideCost" }),
    hasTrips() {
      return this.trips.length > 0;
    }
  },
  components: {
    Trip,
    TableRow,
    PreRate
  },
  mounted() {
    this.getSpoils();
    this.getTips();
  }
};
</script>

<style scoped>
.trip-list-animate-item {
  transition: all 0.3s;
  max-height: 400px;
  margin-right: 10px;
  width: 100%;
}
.trip-list-animate-enter, .trip-list-animate-leave-to
        /* .trip-list-animate-leave-active below version 2.1.8 */ {
  max-height: 0px;
  opacity: 0;
  transform: translateX(-200px);
}
.trip-list-animate-leave-active {
  position: absolute;
}
</style>
